/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A user_session_consent record. Per-client (not per-issuer) consent.
 */
export type UserSessionConsent = {
  consentedAt: Date;
  createdAt: Date;
  /**
   * The user_session_consent id.
   */
  id: string;
  /**
   * SHA-256 of the sorted list of remote_session_issuer ids on the client's owning issuer at consent time.
   */
  remoteSetHash: string;
  /**
   * The consenting subject URN (user:<id> | apikey:<uuid> | anonymous:<mcp-session-id>).
   */
  subjectUrn: string;
  updatedAt: Date;
  /**
   * The user_session_client this consent binds to.
   */
  userSessionClientId: string;
};

/** @internal */
export const UserSessionConsent$inboundSchema: z.ZodMiniType<
  UserSessionConsent,
  unknown
> = z.pipe(
  z.object({
    consented_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    remote_set_hash: z.string(),
    subject_urn: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_session_client_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "consented_at": "consentedAt",
      "created_at": "createdAt",
      "remote_set_hash": "remoteSetHash",
      "subject_urn": "subjectUrn",
      "updated_at": "updatedAt",
      "user_session_client_id": "userSessionClientId",
    });
  }),
);

export function userSessionConsentFromJSON(
  jsonString: string,
): SafeParseResult<UserSessionConsent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserSessionConsent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserSessionConsent' from JSON`,
  );
}
